import React from 'react'

interface IButton {
    buttonText: string
    onClick?: () => void
    colorGreen?: boolean
    type?: "button" | "submit" | "reset" | undefined
    disabled?: boolean
}

const Button = ({buttonText="Next", onClick, colorGreen=true, type, disabled}:IButton) => {
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`__button ${colorGreen ? "__c-green" : "__c-white"}`}>
        {buttonText}
    </button>
  )
}

export default Button